module.exports = __webpack_public_path__ + "static/alec-pointing-b7ae5237cfd49c708ca1427c44eeee4b.png";